import axios from "axios"

export default {
  // weatherData(coordinate) {
  //   return axios.get(`http://api.weatherapi.com/v1/forecast.json?key=27ec0c50b82e44f8a39114625232008&q=${coordinate}&days=1&aqi=no&alerts=no`)
  // },
  weatherData(coordinate) {
    return axios.get(`https://api.weatherapi.com/v1/forecast.json?key=${process.env.VUE_APP_API_KEY_WEATHER}&q=${coordinate}&days=1&aqi=no&alerts=no`)
  },
}